import React from 'react';
import { Button, Grid, FormControl, Typography, InputAdornment } from '@mui/material';
import { useForm } from 'react-hook-form';
import ValidatableField from './ValidatableField';
function RotationForm({ message, onSubmit }) {
    const { register, formState, handleSubmit: validate } = useForm({ mode: 'onChange' });
    const { errors } = formState;
    const [disabled, setDisabled] = React.useState(true);
    const [pitch, setPitch] = React.useState(0);
    const [yaw, setYaw] = React.useState(0);
    const [roll, setRoll] = React.useState(0);
    const handleSubmit = () => {
        setDisabled(true);
        onSubmit({ pitch, yaw, roll });
        setTimeout(() => setDisabled(false), 2500);
    };
    React.useEffect(() => setDisabled(!pitch && !yaw && !roll), [pitch, yaw, roll]);
    return (React.createElement("form", { onSubmit: validate(handleSubmit) },
        React.createElement(Grid, { container: true, spacing: 1 },
            message ? (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "body2" }, message))) : null,
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "pitch", label: "Pitch", placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, '\u33AD'),
                        }, inputProps: {
                            step: 'any',
                        }, defaultValue: 0, value: pitch, registerOptions: {
                            onChange: (e) => setPitch(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "yaw", label: "Yaw", placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, '\u33AD'),
                        }, inputProps: {
                            step: 'any',
                        }, defaultValue: 0, value: yaw, registerOptions: {
                            onChange: (e) => setYaw(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "roll", label: "Roll", placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, '\u33AD'),
                        }, inputProps: {
                            step: 'any',
                        }, defaultValue: 0, value: roll, registerOptions: {
                            onChange: (e) => setRoll(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sx: { display: 'flex', justifyContent: 'flex-end' } },
                React.createElement(Button, { type: "submit", disabled: disabled }, "Submit")))));
}
export default React.memo(RotationForm);
